export const IMPPROFESSIONALGOALAction = {
    AddProfessionalGoal: "ADDPROFESSIONALGOAL",
    RemoveProfessionalGoal: "REMOVEPROFESSIONALGOAL",
}

   const udpatedProfessionalGoals = [];

   const ImportProfessionalGoalsReducer = (updtGoals = udpatedProfessionalGoals, actions) => {
       switch (actions.type) {
           case IMPPROFESSIONALGOALAction.AddProfessionalGoal:
             updtGoals.push(actions.payload);
             return updtGoals;
           case IMPPROFESSIONALGOALAction.RemoveProfessionalGoal:
             updtGoals = [];
             return updtGoals;
            default:
            return updtGoals;
       }
    }
    export default ImportProfessionalGoalsReducer;